import { render } from "./ModuleStyleguideElements.vue?vue&type=template&id=457953f3"
import script from "./ModuleStyleguideElements.vue?vue&type=script&lang=js"
export * from "./ModuleStyleguideElements.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__